// HelmetItem.jsx
import { Helmet } from 'react-helmet';
import { CompanyName } from '../../utils/Constants';

export const HelmetItem = ({
  PageName,
  desc,
  keywords,
  additionalMeta = [],
  structuredData = null,
  noIndex = false,
  links = [], // NEW
}) => {
  return (
    <Helmet>
      <title>{PageName} - {CompanyName}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}

      {additionalMeta.map((meta, index) => (
        <meta key={index} {...meta} />
      ))}

      {/* NEW: link tags (preload, preconnect, etc.) */}
      {links.map((linkProps, i) => (
        <link key={i} {...linkProps} />
      ))}

      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};
